import ConfirmSwapDevices from '@/vue/components/modals/ConfirmSwapDevicesModal';
import VrmAddInstallation from '@/vue/components/shared/VrmAddInstallation';

/**
 * @ngdoc Controller
 * @name TagSettingsController
 */
(function () {
    'use strict';

    angular.module('vrm.core').controller('GeneralSettingsController', GeneralSettingsController).filter('swapInstallationFilter', swapInstallationFilter);

    /**
     * @constructor
     * @ngInject
     */
    function swapInstallationFilter() {

        return function (installations, idSite) {
            var output = [];
            if (_.size(installations)) {
                output = _.filter(installations, function (installation) {
                    // You cannot swap to current installation
                    if (installation.idSite == idSite) return false;
                    // You can only swap to installations you have admin access
                    return installation.view_permissions.update_settings;
                });

            }
            return output;
        };
    }

    /**
     * @constructor
     * @ngInject
     */
    function GeneralSettingsController(
        $log,
        $scope,
        $rootScope,
        $state,
        $stateParams,
        InstallationsService,
        ApiService,
        SwapInstallationService,
        vrmNotificationsService,
        vrmNotificationType,
        locale,
        VrmModalService,
        $location,
        InstallationAvatarService
    ) {
        $log.info('GeneralSettingsController');

        $scope.transfer = {
            selectedSite: null
        };

        $scope.forms = {};
        $scope.generalModel = {
            name: null,
            portal: null,
            siteID: null,
            gsm: null,
            currency: null,
            setCurrency: c => $scope.generalModel.currency = c,
        };

        $scope.users = [];
        $scope.installation = null;

        $scope.realtime = true;
        $scope.loadingRealtime = true;

        $scope.inverterChargerControl = true;
        $scope.loadingInverterChargerControl = true;
        $scope.showInverterSection = false;
        $scope.showResetSolarForecastsSection = false;

        $scope.swapInstallationsModel = SwapInstallationService.swapInstallationsModel;

        $scope.remoteConsoleUI = null;
        $scope.savingRemoteConsoleChoice = false;

        SwapInstallationService.initModel();

        ApiService.installations($stateParams.id, 'users').then(function (response) {
            $scope.users = response.data.users;
        });

        ApiService.installations($stateParams.id, 'stats', {
            start: Math.floor(new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000),
            end: Math.floor(new Date(new Date().setHours(23, 59, 59, 999)).getTime() / 1000),
            interval: "hours",
            type: "forecast"
        }).then(function (response) {
            if (response.data.totals.solar_yield_forecast !== false || response.data.records.solar_yield_forecast !== false) {
                $scope.showResetSolarForecastsSection = true;
            }
        });

        $scope.openAddInstallationModal = function () {
            VrmModalService.openVueModal(VrmAddInstallation, {context: 'general'});
        }

        $scope.confirmReplace = function () {
            VrmModalService.openVueModal(ConfirmSwapDevices, {
                swapInstallationsModel: $scope.swapInstallationsModel,
                context: 'general',
                initialStep: 1
            });
        }

        const findInverterChargerInstance = (installation) => {
            return installation.extended.find(({code}) => code === "ss")
        };

        const setShowInverterSection = (installation) => {
            $scope.showInverterSection =
                installation.view_permissions.update_settings &&
                installation.view_permissions.twoway &&
                installation.realtimeUpdates &&
                !!findInverterChargerInstance(installation);
        }

        const redirectUnauthorizedUser = (installation) => {
            if (!installation.view_permissions.update_settings) {
                InstallationsService.redirectUnauthorizedUser(installation);
            }
        }

        InstallationsService.getInstallation($stateParams.id).then(function (installation) {
            redirectUnauthorizedUser(installation);

            $scope.installation = installation;
            $scope.installationName = installation.name;
            $scope.generalModel.name = installation.name;
            $scope.generalModel.siteID = installation.idSite;
            $scope.generalModel.portal = installation.identifier;
            $scope.generalModel.gsm = installation.phonenumber;
            $scope.generalModel.currency = installation.currency;
            $scope.realtime = installation.realtimeUpdates;
            $scope.loadingRealtime = false;
            $scope.inverterChargerControl = !!installation.inverterChargerControl;
            $scope.loadingInverterChargerControl = false;
            $scope.remoteConsoleUI = installation.remoteConsoleChoice;
            $scope.hasRemoteConsoleUIChanged = false;

            setShowInverterSection(installation);

            $scope.save = function () {
                if (!$scope.forms.generalForm.$valid) return;

                ApiService.installationSettings($stateParams.id, {
                    description: $scope.generalModel.name,
                    phonenumber: $scope.generalModel.gsm,
                    currency: $scope.generalModel.currency.idCurrency
                }).then(function () {
                    //Update installation without reloading
                    installation.name = $scope.generalModel.name;
                    installation.phonenumber = $scope.generalModel.gsm;
                    installation.currency = $scope.generalModel.currency;
                });
            };

            $scope.cancel = function () {
                $scope.generalModel.name = installation.name;
                $scope.generalModel.gsm = installation.phonenumber;
                $scope.generalModel.currency = installation.currency;
            };

            $scope.redirectDashboard = function (event) {
                if (event.target.tagName.toLowerCase() === "a") {
                    $state.go('base.installation.dashboard', {id: $stateParams.id, openControls: 1})
                }
            }

            $scope.toggleInverterChargerControl = function (checked) {
                if (checked) {
                    VrmModalService.openConfirmModal($scope, 'toggle_inverter_charger_control', function (confirmed) {
                        if (confirmed) {
                            setInverterChargerControlSetting(checked)
                        }
                    }, {
                        yesBtnClass: 'sg-red',
                        noBtnClass: 'sg-site',
                        noTranslation: "common.cancel",
                        yesTranslation: "common.confirm"
                    });
                } else {
                    setInverterChargerControlSetting(checked)
                }
            }

            const setInverterChargerControlSetting = function (inverterChargerControl) {
                if (installation.inverterChargerControl != inverterChargerControl) {
                    $scope.loadingInverterChargerControl = true;
                    ApiService.installationSettings($stateParams.id, {
                        inverterChargerControl,
                    }).then(function () {
                        $scope.inverterChargerControl = installation.inverterChargerControl = inverterChargerControl;
                    }).finally(function () {
                        $scope.loadingInverterChargerControl = false;
                    })
                }
            }

            $scope.$watch('realtime', function (realtime) {
                if (installation.realtimeUpdates !== realtime) {
                    $scope.loadingRealtime = true;
                    ApiService.installationSettings($stateParams.id, {
                        realtimeUpdates: realtime,
                    }).then(function () {
                        installation.realtimeUpdates = realtime;
                        if (realtime) {
                            InstallationsService.setRealtimeInstallation(installation);
                        } else {
                            InstallationsService.setRealtimeInstallation(null);
                        }
                        setShowInverterSection(installation);
                    }).finally(function () {
                        $scope.loadingRealtime = false;
                    });
                }
            });

            if ($location.hash() === "resetAuthToken") {
                $("body, html").stop().animate({scrollTop: angular.element('#resetAuthToken').offset().top}, "slow");
            }
        });

        $scope.onRemoteConsoleUIChanged = (choice) => {
            $scope.remoteConsoleUI = choice;
            $scope.hasRemoteConsoleUIChanged = true;
        };

        $scope.onRemoteConsoleUISaved = () => {
            if ($scope.hasRemoteConsoleUIChanged) {
                $scope.savingRemoteConsoleChoice = true;

                ApiService.setRemoteConsolePreference($scope.installation.idSite, $scope.remoteConsoleUI).then((response) => {
                    $scope.hasRemoteConsoleUIChanged = false;

                    vrmNotificationsService.add({
                        type: vrmNotificationType.SUCCESS,
                        message: locale.getString('remoteconsole.setting_ui_success_msg')
                    });

                    // Notify nav bar that remote console UI changed.
                    $rootScope.$broadcast('rc-changed', $scope.remoteConsoleUI);

                    $scope.savingRemoteConsoleChoice = false;
                }).catch((err) => {
                    $scope.savingRemoteConsoleChoice = false;
                });
            }
        };

        $scope.hasRemoteConsoleChoice = () => {
            if (!$scope.installation) {
                return false;
            }

            const viewPermissions = $scope.installation.view_permissions;
            return (viewPermissions.rc_classic && $scope.installation.GUIv !== 2) && viewPermissions.rc_gui_v2;
        };

        var _next = function () {
            if ($scope.confirmed) {
                //Reload installations list
                InstallationsService.reload();
            }
        };

        $scope.confirmed = false;
        $scope.unlink = function () {
            $scope.confirmed = false;
            VrmModalService.openConfirmModal($scope, 'unlink', function (confirmed) {
                if (confirmed) {
                    $scope.confirmed = true;
                    ApiService.installations($stateParams.id, 'unlink', null, 'POST').then(function () {
                        vrmNotificationsService.add({
                            type: vrmNotificationType.SUCCESS,
                            message: locale.getString('general.unlinked')
                        });
                        $state.go("base.installation-overview");
                    });
                }
            });

            VrmModalService.next(_next)
        };

        $scope.resetSolarForecasts = function () {
            $scope.confirmed = false;
            VrmModalService.openConfirmModal($scope, 'reset_forecasts', function (confirmed) {
                if (confirmed) {
                    $scope.confirmed = true;
                    ApiService.installations($stateParams.id, 'reset-forecasts', {resetType: "solar"}, 'POST').then(function () {
                        vrmNotificationsService.add({
                            type: vrmNotificationType.SUCCESS,
                            message: locale.getString('general.reset_forecasts_successful')
                        });
                    });
                }
            });

            VrmModalService.next(_next)
        }

        $scope.remove = function () {
            $scope.confirmed = false;
            VrmModalService.openConfirmFieldModal($scope, 'delete_site', {expectedFieldValue: $scope.installationName}, function (confirmed) {
                if (confirmed) {
                    $scope.confirmed = true;
                    ApiService.installations($stateParams.id, 'remove', null, 'POST').then(function () {
                        vrmNotificationsService.add({
                            type: vrmNotificationType.SUCCESS,
                            message: locale.getString('general.removed')
                        });
                        $state.go("base.installation-overview");
                    });
                }
            });

            VrmModalService.next(_next)
        };

        $scope.hasAtLeastOneAdmin = function (users) {
            var adminCount = 0;
            for (var i = 0; i < users.length; i++) {
                if (users[i].accessLevel) {
                    adminCount++;
                }
            }
            return adminCount > 1;
        };

        $scope.reset = function () {
            $scope.confirmed = false;
            VrmModalService.openConfirmModal($scope, 'reset', function (confirmed) {
                if (confirmed) {
                    $scope.confirmed = true;
                    ApiService.installations($stateParams.id, 'reset', null, 'POST').then(function () {
                        $scope.installation.invalidVRMAuthTokenUsedInLogRequest = 0;
                        vrmNotificationsService.add({
                            type: vrmNotificationType.SUCCESS,
                            message: locale.getString('general.reset_successful')
                        });
                    });
                }
            });
            VrmModalService.next(_next);
        };


        $scope.openAvatarModal = function () {
            InstallationAvatarService.openAvatarModal($scope, $scope.installation);
        };

        $scope.addInstallationLink = function () {
            const url = $state.href('base.add-installation', {}, {
                absolute: true,
            });
            return `<a href="${url}" target="_blank">${url}</a>`;
        }

        $rootScope.$on('rc-changed', (v) => {
            InstallationsService.getInstallation($stateParams.id, true).then((installation) => {
                $scope.installation = installation;
                $scope.hasRemoteConsoleUIChanged = false;
                $scope.remoteConsoleUI = installation.remoteConsoleChoice;
            });
        });
    }
})();
